import { Grid as MantineGrid } from "@mantine/core";

import type { FC } from "react";

interface GridProps {
  children: React.ReactNode;
}

export const Grid: FC<GridProps> = ({ children }) => {
  return (
    <MantineGrid mt="md" w="100%" maw="100%" gap="md" p={0}>
      {children}
    </MantineGrid>
  );
};
